'use strict';

var appTypes = require('../types/appTypes');
var _ = require('underscore');

exports.getLinkAnimateBySaveLinkAnimate = function(animateType) {
  switch (animateType) {
    case appTypes.PageLinkAnimateType.NONE:
      return '';
    case appTypes.PageLinkAnimateType.PUSH_LEFT:
      return 'push-left';
    case appTypes.PageLinkAnimateType.PUSH_RIGHT:
      return 'push-right';
    case appTypes.PageLinkAnimateType.PUSH_UP:
      return 'push-up';
    case appTypes.PageLinkAnimateType.PUSH_DOWN:
      return 'push-down';
    case appTypes.PageLinkAnimateType.SLIDE_LEFT:
      return 'slide-left';
    case appTypes.PageLinkAnimateType.SLIDE_RIGHT:
      return 'slide-right';
    case appTypes.PageLinkAnimateType.SLIDE_UP:
      return 'slide-up';
    case appTypes.PageLinkAnimateType.SLIDE_DOWN:
      return 'slide-down';
    case appTypes.PageLinkAnimateType.FADE:
      return 'fade';
    case appTypes.PageLinkAnimateType.IRIS:
      return '';
  }
  return '';
};




// WEBPACK FOOTER //
// ./src/helper/linkHelper.jsx